import { render } from "./transaction-item-skeleton.vue?vue&type=template&id=c0d39892"
import script from "./transaction-item-skeleton.vue?vue&type=script&lang=js"
export * from "./transaction-item-skeleton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__